module.exports = __webpack_public_path__ + "img/hearts.3e55b61.webp";